export default function debounce(func: () => void, wait: number, immediate: boolean) {
  let timeout: any;

  return function(this: any) {
    const callNow = immediate && !timeout;

    const later = () => {
      timeout = null;
      if (!immediate) func.apply(this);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(this);
  };
}
